import { Routes } from '@angular/router';
import { AuditListComponent } from './audit-list.component';
import { CanDeactivateGuard } from '../../../core/can-deactivate/can-deactivate.guard';

export const auditListRoutes: Routes = [
  {
    path: 'audit/performed/draft',
    component: AuditListComponent,
    canDeactivate: [CanDeactivateGuard],
    data: { action: 'auditsPerformedDraft' }
  },
  {
    path: 'audit/performed/waiting',
    component: AuditListComponent,
    canDeactivate: [CanDeactivateGuard],
    data: { action: 'auditsPerformedWaiting' }
  },
  {
    path: 'audit/performed/validated',
    component: AuditListComponent,
    canDeactivate: [CanDeactivateGuard],
    data: { action: 'auditsPerformedValidated' }
  },
  {
    path: 'audit/internal/draft',
    component: AuditListComponent,
    canDeactivate: [CanDeactivateGuard],
    data: { action: 'auditsInternalDraft' }
  },
  {
    path: 'audit/internal/waiting',
    component: AuditListComponent,
    canDeactivate: [CanDeactivateGuard],
    data: { action: 'auditsInternalWaiting' }
  },
  {
    path: 'audit/internal/validated',
    component: AuditListComponent,
    canDeactivate: [CanDeactivateGuard],
    data: { action: 'auditsInternalValidated' }
  },
];



// WEBPACK FOOTER //
// /home/web_clients/qualicheck.fr/preprod/erp/src/app/pages/audits/audit-list/audit-list.routing.ts